const defaultVaryings = `
varying vec3 vVertexPosition;
varying vec2 vTextureCoord;
`;
export default defaultVaryings.replace(/\n/g, '');